import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import { Briefcase, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Careers: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <section className="pt-24 pb-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Careers</h2>
              <div className="w-24 h-1 bg-[#d40715] mx-auto mb-6"></div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 mb-8">
              <p className="text-gray-600 mb-6 text-justify">
                Hop Shing Engineering & Construction Limited is a leading sub-contractor and therefore offers high-calibre construction personnel the ability to develop a career.
              </p>
              <p className="text-gray-600 mb-6 text-justify">
                We also take the long-term approach, so you can be sure that the effort you put in today will be the foundation of your future within the company.
              </p>
              <p className="text-gray-600 mb-6 text-justify">
                Our staff/employee turnover is very low compared to the industry standard, and we have several employees who have chosen to stick with the company since its initial incorporation.
              </p>
              <p className="text-gray-600 text-justify">
                If you have a hands-on approach to construction works and the drive to get things done, and a friendly attitude, then we would very much like to hear from you and have you within our skilled team of construction personnel.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 mb-8">
              <div className="flex items-center gap-3 mb-6">
                <Briefcase className="text-[#d40715]" size={24} />
                <h3 className="text-2xl font-bold text-gray-800">Present Vacancies</h3>
              </div>

              <div className="space-y-6">
                <div className="border-l-4 border-[#d40715] pl-4">
                  <h4 className="text-xl font-semibold text-gray-800 mb-2">Quantity Surveyor (QS)</h4>
                  <p className="text-gray-600 mb-4">
                    We have a vacancy for an experienced quality surveyor to join our team.
                  </p>
                  <p className="text-gray-600">
                    If you are interested in this position, then please contact us now for an interview.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-[#d40715] rounded-lg shadow-md p-8 text-white">
              <div className="flex items-center gap-3 mb-6">
                <Mail size={24} />
                <h3 className="text-2xl font-bold">Get in Touch</h3>
              </div>
              <p className="mb-6">
                Please feel free to ask us more about career/employment opportunities with Hop Shing and any related questions that you may have.
              </p>
              <button 
                onClick={() => {
                  navigate('/contact');
                  window.scrollTo(0, 0);
                }}
                className="bg-white text-[#d40715] px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </section>
      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default Careers;